module.exports = __webpack_public_path__ + "library/img/KahalaLogo_yoko1w.webp";